import { PersonAddOutlined, PersonRemoveOutlined } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setFriends } from "state";
import FlexBetween from "./FlexBetween";
import UserImage from "./UserImage";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useState } from "react";

const Friend = ({ friendId, name, subtitle, userPicturePath, loggedInUserId }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { _id } = useSelector((state) => state.user);
    const token = useSelector((state) => state.token);
    const friends = useSelector((state) => state.user.friends);
    // console.log("Friends:", friends);

    const [bookMarkIcon, setBookamrkIcon] = useState(false)

    const { palette } = useTheme();
    const primaryLight = palette.primary.light;
    const primaryDark = palette.primary.dark;
    const main = palette.neutral.main;
    const medium = palette.neutral.medium;

    const handleBookmarkIcon = () => {
        setBookamrkIcon(!bookMarkIcon)
    }

    const isFriend = Array.isArray(friends) && friends.find((friend) => friend._id === friendId);
    const patchFriend = async () => {
        const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/users/${_id}/${friendId}`,
            {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        const data = await response.json();
        dispatch(setFriends({ friends: data }));
    };

    return (
        <FlexBetween>
            <FlexBetween gap="1rem">
                <UserImage image={userPicturePath} size="55px" />
                <Box
                    onClick={() => {
                        navigate(`/profile/${friendId}`);
                        navigate(0);
                    }}
                >
                    <Typography
                        color={main}
                        variant="h5"
                        fontWeight="500"
                        sx={{
                            "&:hover": {
                                color: palette.primary.light,
                                cursor: "pointer",
                            },
                        }}
                    >
                        {name}
                    </Typography>
                    <Typography color={medium} fontSize="0.75rem">
                        {subtitle}
                    </Typography>
                </Box>
            </FlexBetween>

            <Box>
                <IconButton onClick={handleBookmarkIcon} >
                    {bookMarkIcon ? (
                        <BookmarkIcon />
                    ) : (
                        <BookmarkBorderIcon />
                    )}
                </IconButton>

                {loggedInUserId !== friendId && (
                    <IconButton
                        onClick={() => patchFriend()}
                        sx={{ backgroundColor: primaryLight, p: "0.6rem" }}
                    >
                        {isFriend ? (
                            <PersonRemoveOutlined sx={{ color: primaryDark }} />
                        ) : (
                            <PersonAddOutlined sx={{ color: primaryDark }} />
                        )}
                    </IconButton>
                )}
            </Box>



        </FlexBetween>
    );
};

export default Friend;